import React, { useState, useEffect, useMemo, useRef } from 'react';

function DynamicTypeAnimation({ message }) {
  // Bersihkan pesan dengan menghapus kata "undefined" (jika ada dalam teks asli)
  const cleanMessage = useMemo(() => {
    return (message || "").trim(); // Hapus spasi ekstra di awal/akhir
  }, [message]);

  // Pecah pesan menjadi array kata-kata
  const words = useMemo(() => cleanMessage.split(/\s+/), [cleanMessage]);

  const [displayed, setDisplayed] = useState('');
  const indexRef = useRef(0);
  const isAnimating = useRef(false);

  useEffect(() => {
    if (words.length === 0 || isAnimating.current) return;

    setDisplayed('');
    indexRef.current = 0;
    isAnimating.current = true; // Tandai bahwa animasi sedang berjalan

    let isFast = true;
    const fastSpeed = 50;
    const slowSpeed = 300;
    let currentSpeed = fastSpeed;
    let groupSize = Math.floor(Math.random() * 8) + 3;

    function animate() {
      if (indexRef.current >= words.length) {
        isAnimating.current = false; // Animasi selesai
        return;
      }

      // **Pastikan tidak menambahkan undefined**
      const nextWord = words[indexRef.current] || ''; // Jika undefined, pakai string kosong
      setDisplayed(prev => prev + (prev ? ' ' : '') + nextWord);

      indexRef.current++;
      groupSize--;

      if (groupSize === 0 && indexRef.current < words.length) {
        isFast = !isFast;
        currentSpeed = isFast ? fastSpeed : slowSpeed;
        groupSize = Math.floor(Math.random() * 8) + 3;
      }

      setTimeout(animate, currentSpeed);
    }

    animate();
  }, [words]);

  return <span>{displayed}</span>;
}

export default React.memo(DynamicTypeAnimation);
